import { EsaSessionData } from "@outschool/auth-shared";
import { CookieKeys } from "@outschool/data-schemas";
import { OUTSCHOOL_TIMEZONE, dayjs } from "@outschool/time";
import Cookies from "js-cookie";

export const getEsaSession = (): EsaSessionData => {
  return JSON.parse(Cookies.get(CookieKeys.EsaSession) || "null");
};

export const isEsaSessionPresent = () => {
  return !!getEsaSession();
};

export const esaCheckoutUrl = (
  orderSlugId: string,
  callbackUrl: string,
  vendorId: string
) => {
  const { cwUrl } = getEsaSession();
  return `${cwUrl}/payby-checkout/?callback=${callbackUrl}/api/cw/order/${orderSlugId}&vendorId=${vendorId}`;
};

export const destroyEsaSession = () => {
  Cookies.remove(CookieKeys.EsaSession);
};

export const getEsaFundName = (): String => {
  const esaState = getEsaSession()?.shipping?.state;

  switch (esaState) {
    case "TX":
      return "SSES";
    case "NC":
      return "ESA+";
    case "VA":
      return "LAG";
    case "NH":
      return "EFA";
    case "NY":
      return "CSF-NY";
    default:
      return "ESA";
  }
};

export const getEsaWaitPeriod = (): number => {
  const esaState = getEsaSession()?.shipping?.state;

  switch (esaState) {
    case "TX":
      return 3;
    case "NC":
      return 5;
    case "NH":
      return 2;
    case "VA":
      return 2;
    case "NY":
      return 5;
    default:
      // Currently AZ
      return 0;
  }
};

export const getEsaEndDate = (ignoreFirstDeadline = false): Date | null => {
  const esaState = getEsaSession()?.shipping?.state;

  switch (esaState) {
    case "VA":
      const deadlines = [
        new Date("2023-12-30T23:59:00"),
        new Date("2024-05-30T23:59:00"),
      ];
      const date = getNextValidESADeadline(deadlines, ignoreFirstDeadline);
      return date;
    default:
      return null;
  }
};

export const getNextValidESADeadline = (
  deadlines: Date[],
  ignoreFirstDeadline: boolean
): Date | null => {
  if (!deadlines || deadlines.length < 1) {
    return null;
  }

  const today = dayjs();
  let firstDeadlineIgnored = false;

  for (const date of deadlines) {
    if (
      dayjs
        .tz(today, OUTSCHOOL_TIMEZONE)
        .isAfter(dayjs.tz(dayjs(date), OUTSCHOOL_TIMEZONE))
    ) {
      continue;
    } else {
      if (ignoreFirstDeadline && !firstDeadlineIgnored) {
        firstDeadlineIgnored = true;
        continue;
      } else {
        return date;
      }
    }
  }
  return null;
};
